// extracted by mini-css-extract-plugin
export var bodyRow = "_ea-d";
export var cardColumns = "_ea-e";
export var ellipsesOverflow = "_ea-2";
export var flatBottomCorners = "_ea-3";
export var flatTopCorners = "_ea-4";
export var headerActionsDropdown = "_ea-f";
export var headerBottomRow = "_ea-c";
export var headerTopRow = "_ea-b";
export var orderDetailsWrapper = "_ea-0";
export var orderInfoContainer = "_ea-1";
export var productDetails = "_ea-9";
export var productImage = "_ea-5";
export var responsiveTable = "_ea-8";
export var shipmentContainer = "_ea-a";
export var tableBottomLeft = "_ea-6";
export var tableBottomRight = "_ea-7";